import React from 'react';
import TabbedSection from '../components/TabbedSection';

import Categories from './Categories/Categories';
import Books from './Books/Books';
import OtherBooks from './OtherBooks/OtherBooks';
import LanguageGuides from './LanguageGuides/LanguageGuides';
import Bundles from './Bundles/Bundles';
import Coupons from './Coupons/Coupons';
import CompanionOffers from './CompanionOffers/CompanionOffers';

/**
 * Everything that makes up the catalogue and how it is priced.
 *
 * Travel guides lead because they are the bulk of it; categories sit first
 * because a guide cannot exist without one.
 */
const TABS = [
    { key: 'categories', label: 'Categories', Component: Categories },
    { key: 'travel-guides', label: 'Travel Guides', Component: Books },
    { key: 'other-guides', label: 'Other Guides', Component: OtherBooks },
    { key: 'language-guides', label: 'Language Guides', Component: LanguageGuides },
    { key: 'bundles', label: 'Bundles', Component: Bundles },
    { key: 'coupons', label: 'Coupons', Component: Coupons },
    { key: 'free-offers', label: 'Free Offers', Component: CompanionOffers },
];

const WebsiteApp = () => <TabbedSection title="Website & App" basePath="/website-app" tabs={TABS} />;

export default WebsiteApp;
